import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DetailHeaderTemplateComponent } from "./detail-header-template.component";

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    DetailHeaderTemplateComponent,
  ],
  exports: [
    DetailHeaderTemplateComponent,
  ],
})

export class DetailHeaderTemplateModule {

}
